export default __webpack_public_path__ + "static/am-fo-map-fbefc93c56b2c8f6b97454cd58a958be.png";